import MobileUiView from "./selected/MobileUiView";
import DynamicItemList from "./dynamic_items/DynamicItemList";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {resetAll} from "../../redux/slices/dynamicElementsSlice";
import {resetAll as resetAllDynamic} from "../../redux/slices/dynamicMultipleElementsSlice";
import {resetSelectedItems, resetItems, resetPlatform, resetPages, resetSearchResult} from "../../redux/slices/dynamicUiSlice";
import {resetAllSearch} from "../../redux/slices/searchSlice";


export default function DynamicUiPage() {
  const isMobileViewSelected = useSelector((state) => state.dynamicUi.isPlatformMobile);
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAll());
      dispatch(resetAllDynamic());
      dispatch(resetSelectedItems());
      dispatch(resetItems());
      dispatch(resetAllSearch());
      dispatch(resetPlatform());
      dispatch(resetPages());
      dispatch(resetSearchResult());
    };
  }, []);


  return (
    <>
      <div className="px-3 2xl:px-5 h-auto -mt-24">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-5">
            <div className={`lg:col-start-1 lg:col-end-4 px-2 2xl:px-4 mb-16${isMobileViewSelected ? ' mobile' : ''}`}>
              <MobileUiView/>
            </div>
            <div className="lg:col-start-4 lg:col-end-6  px-2 2xl:px-4 mb-16">
              <DynamicItemList/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
